<template>
  <div>


<h2 class="goth">Subjunktioner</h2>

<div class="grammatikparagrafbredd leftorient">
<p>Subjunktioner eller underordnade konjunktioner kallas sådana konjunktioner som inleder <i>bisats</i>.</p>

<p>Tabellen nedan visar några vanliga subjunktioner:</p>
<table class="">

    <tr>
        <td class="ljusgra">
            <b>als</b>
        </td>
        <td class="ljusgra">
            när (i förfluten tid)
        </td>
    </tr>

    <tr>
        <td class="ljusgra">
            <b>damit</b>
        </td>
        <td class="ljusgra">
            för att, så att
        </td>
    </tr>

    <tr>
        <td class="ljusgra">
            <b>dass</b>
        </td>
        <td class="ljusgra">
            att
        </td>
    </tr>



    <tr>
        <td class="ljusgra">
            <b>ob</b>
        </td>
        <td class="ljusgra">
            om, huruvida
        </td>
    </tr>

    <tr>
        <td class="ljusgra">
            <b>obwohl</b>
        </td>
        <td class="ljusgra">
            fastän
        </td>
    </tr>

    <tr>
        <td class="ljusgra">
            <b>weil</b>
        </td>
        <td class="ljusgra">
            eftersom, (där)för att
        </td>
    </tr>



</table>

<div class="quasi-p">Ordföljden i en tysk bisats är annorlunda än i en huvudsats. I en <b>bisats</b>
    hamnar alltid det <b>finita verbet sist</b>, d.v.s. det verb som är böjt efter
    subjektet (ibland kan flera verb förekomma, t.ex. vid modala hjälpverb, men det finita verbet hamnar ändå sist).</div>

<p>Exempel med ett verb</p>
<div class="ruta" style="padding-top:5px;padding-bottom:5px;">
<div class="p-stil"><div class="dubbelrad"><u><i>Peter <div class="accented">hat</div> ein Buch.</i></u> &nbsp; <br>
    <div class="minitext">&nbsp;&nbsp;&nbsp;huvudsats</div></div>

<br><i>Peter har en bok.</i></div>

<br><br>
<div>
<div class="p-stil"><div class="dubbelrad"><u><i>Ich weiß,</i></u> &nbsp; <br>
    <div class="minitext">&nbsp;&nbsp;&nbsp;huvudsats</div></div></div>


<div class="p-stil"><div class="dubbelrad"><u><i><b>dass </b>Peter ein Buch <div class="accented">hat</div>.</i></u> &nbsp; <br>
    <div class="minitext">&nbsp;&nbsp;&nbsp;<b>bisats</b></div></div></div>
</div>

<p class="upp"><i>Jag vet, att Peter har en bok.</i></p>
</div>
<br>
<p>Exempel med flera verb (varav ett är modalt hjälpverb)</p>



<div class="ruta" style="padding-top:5px;padding-bottom:5px;">
<div class="p-stil"><div class="dubbelrad"><u><i><div class="accented">Kann</div> Peter lesen</i></u>? &nbsp; <br>
    <div class="minitext">&nbsp;&nbsp;&nbsp;frågesats</div></div>
<br><i>Kan Peter läsa?</i></div>
<br><br>
<div>
<div class="p-stil"><div class="dubbelrad"><u><i>Ich weiß nicht,</i></u> &nbsp; <br>
    <div class="minitext">&nbsp;&nbsp;&nbsp;huvudsats</div></div></div>


<div class="p-stil"><div class="dubbelrad"><u><i><b>ob </b>Peter lesen <div class="accented">kann</div>.</i></u> &nbsp; <br>
    <div class="minitext">&nbsp;&nbsp;&nbsp;<b>bisats</b></div></div></div>
</div>
<p class="upp"><i>Jag vet inte, om Peter kan läsa.</i></p>
</div>
<br>
<p>Bisatsen kan stå först i meningen</p>

<div class="ruta" style="padding-top:5px;padding-bottom:5px;">
<div class="p-stil"><div class="dubbelrad"><u><i><b>Wenn</b> es billiger <div class="accented">wird</div>,</i></u> &nbsp; <br>
    <div class="minitext">&nbsp;&nbsp;&nbsp;<b>bisats</b></div></div></div>


<div class="p-stil"><div class="dubbelrad"><u><i>kaufe ich zwei.</i></u> &nbsp; <br>
    <div class="minitext">&nbsp;&nbsp;&nbsp;huvudsats</div></div></div>
<br>
<p class="upp"><i>Om det blir billigare, köper jag två.</i></p>
</div>




<br><br>






</div>


</div>



</template>

<script>
export default {
  name: 'Grammatik',
  props: {
    msg: String
},

metaInfo() {
    return {
        meta: [
            {
                vmid: "description",
                name: "description",
                content: "subjunktioner konjunktioner obwohl weil ob damit als dass"
            }
        ]
    }
},

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
